import uiRouter from '@uirouter/angularjs';
import angular from 'angular';
import { RetailMembershipsControllerModule } from '../../retail/memberships/controllers/RetailMembershipsController';

export const MembershipRetailView = angular
  .module('acme.view.application.membership.retail', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.helpers',
    RetailMembershipsControllerModule,
  ])
  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const membershipRetail = {
      name: 'application.membership.retail',
      url: '/purchase?membershipId&orderContactId&lifecycleType',
      views: {
        'subview-main': {
          controller: 'RetailMembershipsController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/retail/memberships/memberships.tpl.html',
        },
      },
      data: {
        pageTitle: 'Memberships',
        permissions: ['MEMBERSHIP_SALES'],
      },
    };

    $stateProvider.state(membershipRetail);
  }).name;
